export function globalUrl(id: string): string {
  return `unit://${id}`
}
